import PageMeta from '@/components/base/PageMeta';
import Navbar from '@/components/base/Navbar';
import Footer from '@/components/base/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import HotRecommendations from './components/HotRecommendations';
import PlatformAdvantages from './components/PlatformAdvantages';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '非麻瓜漫画',
      url: 'http://wa25w.cn/',
      description: '非麻瓜漫画提供海量免费韩漫在线观看，支持下拉式阅读体验，每日更新最新韩国漫画全集。',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'hello@wa25w.cn',
        contactType: 'customer service',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '非麻瓜漫画',
      url: 'http://wa25w.cn/',
      description: '非麻瓜漫画提供海量免费韩漫在线观看，支持下拉式阅读体验，每日更新最新韩国漫画全集。',
      inLanguage: 'zh-CN',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '非麻瓜漫画-免费韩漫在线阅读网站_最新韩国漫画下拉式观看',
      description: '非麻瓜漫画提供海量免费韩漫在线观看，支持下拉式阅读体验，每日更新最新韩国漫画全集。无需注册即可免费阅读热门韩漫，享受沉浸式漫画阅读体验。',
      url: 'http://wa25w.cn/',
      inLanguage: 'zh-CN',
    },
  ];

  return (
    <>
      <PageMeta
        title="非麻瓜漫画-免费韩漫在线阅读网站_最新韩国漫画下拉式观看"
        description="非麻瓜漫画提供海量免费韩漫在线观看，支持下拉式阅读体验，每日更新最新韩国漫画全集。无需注册即可免费阅读热门韩漫，享受沉浸式漫画阅读体验。"
        keywords="非麻瓜漫画,韩漫网站,韩漫免费观看,下拉式漫画,韩国漫画免费读,韩漫在线,韩国漫画全集"
        canonicalUrl="http://wa25w.cn/"
        jsonLd={jsonLd}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategoryNav />
        <LatestUpdates />
        <HotRecommendations />
        <PlatformAdvantages />
        <Testimonials />
        <CTASection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}